import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

import { NodeIconColorType } from './node-icon.interface';
import { SvgIconDirective } from '@shared/ui/directives';

@Component({
  selector: 'shared-ui-node-icon',
  templateUrl: './node-icon.component.html',
  styleUrls: ['./node-icon.component.css'],
  imports: [NgClass, SvgIconDirective],
})
export class NodeIconComponent {
  iconPath = input<string>('');

  color = input<NodeIconColorType>();

  isPrivate = input<boolean>();

  isShared = input<boolean>();
}
